import { memo } from "react";

const Greeting = memo(function Greeting({ audioPlayer, NotificationSound}) {
    return  <audio ref={audioPlayer} src={NotificationSound} />;
  });
  
  export default Greeting;